/**
 * Fills team/league filter + selector logos from the metaobject-sourced map.
 *
 * The map is rendered once per page as <script type="application/json" data-team-logos>
 * by snippets/team-logos-json.liquid (see that file for why resolution is client-side).
 * Markup renders <img data-team-logo-key="..."> with no src; this resolves each src from
 * the map, on load and again when filters re-render via AJAX (MutationObserver).
 */
(function () {
  var MAP = null;

  function getMap() {
    if (MAP) return MAP;
    var el = document.querySelector('script[data-team-logos]');
    if (!el) return null;
    try {
      MAP = JSON.parse(el.textContent);
    } catch (e) {
      MAP = null;
    }
    return MAP;
  }

  function resolve(map, rawKey) {
    if (!rawKey) return null;
    var key = rawKey.trim().toLowerCase();
    return map[key] || map[key.replace(/-/g, ' ')] || map[key.replace(/\s+/g, '-')] || null;
  }

  function fill() {
    var map = getMap();
    if (!map) return;
    var imgs = document.querySelectorAll('img[data-team-logo-key]:not([data-logo-resolved])');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-logo-resolved', '');
      var url = resolve(map, img.getAttribute('data-team-logo-key'));
      if (url) {
        img.src = url;
        img.removeAttribute('hidden');
      }
    }
  }

  function init() {
    fill();
    if (!('MutationObserver' in window)) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        fill();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
